import { lazy, Suspense } from "react";
import { Route } from "react-router-dom";
import { Routes } from "components/Sentry/Routes";
import ThemeProvider2024 from "components/MuiThemeProvider/ThemeProvider2024";
import ProgramsFiltersProviders from "./Programs/providers/ProgramsFiltersProviders";
import InfoMessageProvider from "providers/InfoMessageProvider";

const Programming = lazy(() => import("./Programming"));
const ProgramEditor = lazy(() => import("./ProgramBuilder/components/ProgramEditor"));
const ProgramCreate = lazy(() => import("./ProgramCreate"));
const ProgramOverview = lazy(() => import("./ProgramOverview"));
const NotFound = lazy(() => import("features/NotFound"));

function ProgrammingRoutes() {
  return (
    <ThemeProvider2024>
      <InfoMessageProvider>
        <ProgramsFiltersProviders>
          <Suspense>
            <Routes>
              <Route path="/" element={<Programming />} />
              <Route path="/create" element={<ProgramCreate />} />
              <Route path="/:programId/edit" element={<ProgramEditor />} />
              <Route path="/:programId" element={<ProgramOverview />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </ProgramsFiltersProviders>
      </InfoMessageProvider>
    </ThemeProvider2024>
  );
}

export default ProgrammingRoutes;
